var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-alarm-view"},[_c('StatPage',{attrs:{"formModel":_vm.formModel,"requestData":_vm.requestData,"formButton":_vm.formButton,"deviceModelBusiType":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }